module.exports = __webpack_public_path__ + "img/print.17e2d5ba.svg";